<template>
  <AccessErrorBase>
    <template #title>
      {{ title }}
    </template>
    <template #errorTitle>
      Site access required
    </template>
    <template #errorText>
      Hey there! It seems like you don't have an active user account or the right permissions to access
      <span class="font-weight-bold">{{ thisSite }}.</span>
      No worries! Just click the button below to fill out the site access request form and we'll get you sorted out.
    </template>
    <template #actions>
      <v-btn color="#328FFF" block x-large @click="requestAccess">
        <span class="white--text">Request Access</span>
      </v-btn>
    </template>
  </AccessErrorBase>
</template>

<script>
import {
  mapActions, mapGetters, mapState,
} from 'vuex';
import AccessErrorBase from '@/components/common/siteCheck/AccessErrorBase.vue';
import SiteRequestAccessForm from '@/lib/requestAccess/models/SiteRequestAccessForm';
import DiscoveryDialogOptions from '@/components/ui/dialogs/DiscoveryDialogOptions';
import { DiscoveryDialogTypes } from '@/lib/ui/dialogs/DiscoveryDialogsFactory';
import indexIdFromUrlMixin from '@/components/common/siteCheck/mixins/indexIdFromUrlMixin';

export default {
  name: 'ForbiddenSiteError',
  components: {
    AccessErrorBase,
  },
  mixins: [
    indexIdFromUrlMixin,
  ],
  computed: {
    ...mapState('common', [
      'currentSiteId',
      'siteInfoForNotFound',
    ]),
    ...mapGetters('common', [
      'userEmail',
    ]),
    siteName() {
      return this.siteInfoForNotFound?.name;
    },
    title() {
      return this.siteName || 'Access Denied';
    },
    thisSite() {
      return this.siteName || 'this site';
    },
  },
  methods: {
    ...mapActions('common', [
      'getSiteInfo',
      'openDialog',
    ]),
    requestAccess() {
      // Handle the request access logic here
      const form = new SiteRequestAccessForm();
      form.email = this.userEmail;
      form.site = this.siteName;

      const dialogOptions = new DiscoveryDialogOptions(DiscoveryDialogTypes.REQUEST_ACCESS, form,
        () => console.log('Closed'));
      this.openDialog(dialogOptions);
    },
  },
  mounted() {
    this.getSiteInfo(this.siteId);
  },
};
</script>

<style scoped>

</style>
